export const nodeUserRegexp = /(@{1}.*).gargantext.org$/;
